module.exports = __webpack_public_path__ + "static/img/intro.a77775d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/exercicies/words-attack/intro.png
// module id = 657
// module chunks = 2 3 4 5 11 13 14 15 16 21 38 39 40